const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/settings/integrations/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
const integrationsSearchSchema = z.object({
  integration_authorization: z.enum(["cancelled", "failed", "succeeded"]).optional(),
  integration_connection_name: z.string().optional()
});
export const Route = createFileRoute("/_protected/_settingsLayout/settings/integrations/")({
  validateSearch: integrationsSearchSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});